<script>
    import GanttHelper, { _gantHelper_hourToPercentageOfTheSecondsRange } from './GanttHelper.js';
  
    export let Label;
    export let StartDate;
    export let EndDate;
    export let Height;
    export let OriginY;
    export let AdjustStamp;
    export let CurrentStyle;
    export let GanttStore;
  
    const {
      GetAdjustedDateInclDaysOff,
    } = GanttStore;

    const fontSize = "14px";
    const lineHeight = "1.5";

    $: active = Label?._active ?? true;

    const toggleActivation = () => {
        Label._active = !(Label?._active ?? true);
    }
  
    const UnclampedCalculateStampXDifferential = (stamp1, stamp2) => UnclampedCalculateStampX(stamp2) - UnclampedCalculateStampX(stamp1);
    const UnclampedCalculateStampX = (stamp) => 100 * GanttHelper._gantHelper_scale($GetAdjustedDateInclDaysOff(AdjustStamp(stamp)).getTime(), EndDate.getTime(), StartDate.getTime());

    const VAlign = {
      "Top":"top",
      "Center":"middle",
      "Bottom":"bottom",
    };
  
    const HAlign = {
      "Left":"start",
      "Center":"center",
      "Right":"end",
    };
  
    $: LabelContent = ((typeof Label._string === 'string') ? Label._string : ((CurrentStyle in Label._string) ? Label._string[CurrentStyle] : "")).replaceAll('\\n', '\n');
    $: ArrowRelativeHeight = ((typeof Label._height === 'object' && CurrentStyle in Label._height) ? Label._height[CurrentStyle] : 0.8);
</script>

<svg
  x="{UnclampedCalculateStampX(Label._timePoint)}%"
  y="{OriginY+Label._relYRatio*Height}%"
  height="{Height*ArrowRelativeHeight}%"
  width="{UnclampedCalculateStampXDifferential(Label._timePoint, new Date(new Date(Label._timePoint).getTime() + Label._timeSpan * 1000))}%"
  >

  {#if active === true}

  <rect
    x="0" y="0" width="100%" height="100%"
    style="
    fill:{Label._backColor};
    stroke-width:1;
    stroke:{Label._borderColor};
    cursor:pointer;
    clip-path: polygon(
    0% 50%,
    {Label._arrowDepthRatio*50}% 0%,
    {Label._arrowDepthRatio*50}% {(1-Label._arrowStemHeightRatio)*50}%,
    {100-(Label._arrowDepthRatio*50)}% {(1-Label._arrowStemHeightRatio)*50}%,
    {100-(Label._arrowDepthRatio*50)}% 0%,
    100% 50%,
    {100-(Label._arrowDepthRatio*50)}% 100%,
    {100-(Label._arrowDepthRatio*50)}% {100-((1-Label._arrowStemHeightRatio)*50)}%,
    {Label._arrowDepthRatio*50}% {100-((1-Label._arrowStemHeightRatio)*50)}%,
    {Label._arrowDepthRatio*50}% 100%
    );
    "
    on:click={() => toggleActivation()}
    />
  <line
    x1="0%"
    y1="50%"
    x2="{Label._arrowDepthRatio*50}%"
    y2="100%"
    stroke="{Label._borderColor}"
    stroke-width="1"
    />
  <line
    x1="{Label._arrowDepthRatio*50}%"
    y1="{100-((1-Label._arrowStemHeightRatio)*50)}%"
    x2="{Label._arrowDepthRatio*50}%"
    y2="100%"
    stroke="{Label._borderColor}"
    stroke-width="1"
    />
  <line
    x1="{Label._arrowDepthRatio*50}%"
    y1="{100-((1-Label._arrowStemHeightRatio)*50)}%"
    x2="{100-(Label._arrowDepthRatio*50)}%"
    y2="{100-((1-Label._arrowStemHeightRatio)*50)}%"
    stroke="{Label._borderColor}"
    stroke-width="1"
    />
  <line
    x1="{100-(Label._arrowDepthRatio*50)}%"
    y1="100%"
    x2="{100-(Label._arrowDepthRatio*50)}%"
    y2="{100-((1-Label._arrowStemHeightRatio)*50)}%"
    stroke="{Label._borderColor}"
    stroke-width="1"
    />
  <line
    x1="{100-(Label._arrowDepthRatio*50)}%"
    y1="100%"
    x2="100%"
    y2="50%"
    stroke="{Label._borderColor}"
    stroke-width="1"
    />
  <line
    x1="{100-(Label._arrowDepthRatio*50)}%"
    y1="0%"
    x2="100%"
    y2="50%"
    stroke="{Label._borderColor}"
    stroke-width="1"
    />
  <line
    x1="{100-(Label._arrowDepthRatio*50)}%"
    y1="0%"
    x2="{100-(Label._arrowDepthRatio*50)}%"
    y2="{(1-Label._arrowStemHeightRatio)*50}%"
    stroke="{Label._borderColor}"
    stroke-width="1"
    />
  <line
    x1="{Label._arrowDepthRatio*50}%"
    y1="{(1-Label._arrowStemHeightRatio)*50}%"
    x2="{100-(Label._arrowDepthRatio*50)}%"
    y2="{(1-Label._arrowStemHeightRatio)*50}%"
    stroke="{Label._borderColor}"
    stroke-width="1"
    />
  <line
    x1="{Label._arrowDepthRatio*50}%"
    y1="{(1-Label._arrowStemHeightRatio)*50}%"
    x2="{Label._arrowDepthRatio*50}%"
    y2="0%"
    stroke="{Label._borderColor}"
    stroke-width="1"
    />
  <line
    x1="0%"
    y1="50%"
    x2="{Label._arrowDepthRatio*50}%"
    y2="0%"
    stroke="{Label._borderColor}"
    stroke-width="1"
    />
  <foreignObject
    x="{Label._arrowDepthRatio*50}%"
    y="{(1-Label._arrowStemHeightRatio)*50}%"
    height="{Label._arrowStemHeightRatio*100}%"
    width="{(1-Label._arrowDepthRatio)*100}%"
    style="cursor:pointer;"
    on:click={() => toggleActivation()}
    >
    <div style="
      display: table;
      height:100%;
      width:100%;
      overflow: hidden;
      pointer-events:none;
      ">
      <div style="
        display: table-cell;
        height:100%;
        width:100%;
        overflow: hidden;
        vertical-align: {VAlign[Label._textVerticalAlignment]};
        text-align:{HAlign[Label._textHorizontalAlignment]};
        color:{Label._textColor};
        padding: 2px;
        white-space: pre-line;
        font-size: {fontSize};
        line-height: {lineHeight};
        pointer-events:none;
        ">
        {LabelContent}
      </div>
    </div>
  </foreignObject>

  {:else}

  <g> 
    <title>{LabelContent}</title>
    <image 
      href="/assets/icons/label_icon_arrow.svg" 
      x="0" 
      y="50%" 
      dominant-baseline="middle"
      height="50px"
      width="50px"
      transform="translate(0, -25)"
      style="cursor:pointer;"
      on:click={() => toggleActivation()}
    />
  </g>
  
  {/if}

</svg>